import { Badge } from "@/components/ui/badge"
import { statusMeta, type StatusDomain, type StatusTone } from "@/lib/status"

const BADGE_VARIANT: Record<StatusTone, "secondary" | "outline" | "destructive"> =
  {
    positive: "secondary",
    neutral: "outline",
    muted: "outline",
    danger: "destructive",
  }

const CHIP_CLASS: Record<StatusTone, string> = {
  positive: "mkt-chip",
  neutral: "mkt-chip mkt-chip--outline",
  muted: "mkt-chip mkt-chip--outline",
  danger: "mkt-chip mkt-chip--outline",
}

/**
 * The one way to render a status enum. `as="chip"` for the marketing/desk
 * surfaces (mkt-chip vocabulary), `as="badge"` for shadcn surfaces (admin).
 */
export function StatusPill({
  domain,
  status,
  as = "chip",
}: {
  domain: StatusDomain
  status: string
  as?: "chip" | "badge"
}) {
  const meta = statusMeta(domain, status)
  if (as === "badge") {
    return <Badge variant={BADGE_VARIANT[meta.tone]}>{meta.label}</Badge>
  }
  return <span className={CHIP_CLASS[meta.tone]}>{meta.label}</span>
}
